import React, { Fragment, useEffect, useState } from "react";
import { Card, Table, Badge } from "reactstrap";
import { CUSTOMER_TRANSACTION_URL } from "../../../constants/ApiPaths";
import { authCustomerHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import { getCustomerUserId } from "../../common/CommonFunctions";
import CustomTableEmptyRecord from "../../common/CustomTableEmptyRecord";
import moment from "moment";
import Pagination from "react-js-pagination";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";

export default function Transaction() {
  const [loading, setloading] = useState(false);
  const [details, setDetails] = useState([]);
  const [totalRecords, setTotalRecords] = useState("");
  const [currentpage, setCurrentPage] = useState(0);
    let rowperpage = 10;

  const getTransactionDetails = async () => {
    setloading(true);
    const config = {
      method: "GET",
      url: CUSTOMER_TRANSACTION_URL,
      headers: authCustomerHeader(),
      params: {
        userId: getCustomerUserId(),
        offset: currentpage,
        count: rowperpage,
      },
    };
    try {
      const response = await API(config);
      const { data, totalCount } = response.data;

      setDetails(data);
      setTotalRecords(totalCount);
    } catch (error) {
      console.error(error);
    } finally {
      setloading(false);
    }
  };
  const onPageChange = (page) => {
    setCurrentPage(page - 1);
  };

  const Status = {
    Pending: "warning",
    Failed: "danger",
    Success: "success",
  };

  useEffect(() => {
    getTransactionDetails();
  }, [currentpage]);
  return (
    <Fragment>
      {loading && <CustomPageLoading />}

      <Card body className="mt-4">
        {details && details.length > 0 ? (
          <Table hover responsive>
            <thead>
              <tr>
                <th>Order #</th>
                <th>Plan Name</th>
                <th>Purchase Date</th>
                <th>Refund Date</th>
                <th>Payment Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {details.map((record, index) => {
                const {
                  planName,
                  refundDate,
                  paymentDate,
                  totalAmount,
                  orderId,
                  paymentStatus,
                } = record;
                return (
                  <tr key={`transaction_${index}`}>
                    <td>#{orderId}</td>
                    <td>{planName}</td>
                    <td>{moment(paymentDate).format("MM/DD/YYYY")}</td>
                    <td>
                      {refundDate
                        ? moment(refundDate).format("MM/DD/YYYY")
                        : "---/---"}
                    </td>

                    <td>${parseFloat(totalAmount || 0).toFixed(2)}</td>
                    <td>
                      <Badge color={Status[paymentStatus]}>
                        {paymentStatus}
                      </Badge>
                    </td>
                  </tr>
                );
              })}
              <div className="d-flex flex-row py-4 justify-content-end">
                <Pagination
                  itemClass="page-item"
                  linkClass="page-link"
                  activePage={currentpage + 1}
                  itemsCountPerPage={rowperpage}
                  totalItemsCount={totalRecords}
                  onChange={onPageChange}
                />
              </div>
            </tbody>
          </Table>
        ) : (
          <CustomTableEmptyRecord />
        )}
      </Card>
    </Fragment>
  );
}
